module.exports = __webpack_public_path__ + "img/13-2.a5ba438b.jpg";